"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPartAtLength = void 0;
const construct_1 = require("./construct");
const getPartAtLength = (p, fractionLength) => {
    const constructed = (0, construct_1.construct)(p);
    if (fractionLength < 0) {
        fractionLength = 0;
    }
    else if (fractionLength > constructed.length) {
        fractionLength = constructed.length;
    }
    let i = constructed.partial_lengths.length - 1;
    while (constructed.partial_lengths[i] >= fractionLength && i > 0) {
        i--;
    }
    i++;
    return { fraction: fractionLength - constructed.partial_lengths[i - 1], i };
};
exports.getPartAtLength = getPartAtLength;
